import { ApprovedAddress, StudentListing } from '../../../shared';

/**
 * Let's us wrap an address or a person into an object that can work with our component for assigning them to groups.
 */
export class GroupMember {
  id?: number; // unique identifier for the actual assignment; null if no assignment has been made yet
  address: ApprovedAddress = null;
  student: StudentListing = null;

  constructor(address: ApprovedAddress, localStudent: StudentListing, campusWardGroupAssignmentId?: number) {
    this.address = address;
    this.student = localStudent;
    this.id = campusWardGroupAssignmentId;
  }

  get title() {
      if (this.address) {
          return this.address.fullAddress;
      } else if (this.student) {
        return `${this.student.lastName}, ${this.student.firstName}`;
      }

      // TODO figure out privacy code

      return '';
  }
}
